import React from 'react';
import useTheme from 'branding/theme';
const CircularProgress = ({ progress, size = 100, strokeWidth = 8, border = false, ...rest }) => {
    const { colors } = useTheme();
    const strokeColors = {
        red: colors.status.fail.alpha,
        orange: colors.brand.secondary.alpha,
        green: colors.status.success.alpha
    };
    const radius = size / 2 - strokeWidth / 2;
    const dasharray = 2 * Math.PI * radius;
    const circleProps = {
        cx: size / 2,
        cy: size / 2,
        r: radius,
        strokeWidth: strokeWidth,
        vectorEffect: 'non-scaling-stroke',
        fill: 'none',
        strokeLinecap: 'round'
    };
    rest.style = {
        transform: 'rotate(-90deg)',
        ...rest.style
    };
    return (React.createElement("svg", { width: size, height: size, ...rest },
        React.createElement("circle", { ...circleProps, stroke: colors.neutrals.borderBeta }),
        progress.map((p, i) => {
            var _a;
            return (React.createElement(React.Fragment, { key: i },
                border && (React.createElement("circle", { ...circleProps, stroke: colors.neutrals.background, strokeDasharray: dasharray, strokeDashoffset: dasharray * ((100 - p.percent) / 100), strokeWidth: strokeWidth + 4 })),
                React.createElement("circle", { ...circleProps, stroke: strokeColors[(_a = p.color) !== null && _a !== void 0 ? _a : 'green'], strokeDasharray: dasharray, strokeDashoffset: dasharray * ((100 - p.percent) / 100) })));
        })));
};
export default CircularProgress;
//# sourceMappingURL=index.js.map